import { useEffect, useState } from "react";

const resolve = (u) => (u && u.startsWith("/")) ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u;

const ImageCarousel = ({ images = [], alt = "", className = "", intervalMs = 3000, testid = "carousel" }) => {
  const slides = (images || []).filter(Boolean);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    if (slides.length <= 1) return;
    const id = setInterval(() => setIdx((i) => (i + 1) % slides.length), intervalMs);
    return () => clearInterval(id);
  }, [slides.length, intervalMs]);

  if (slides.length === 0) return null;
  return (
    <div className={`relative w-full h-full overflow-hidden ${className}`} data-testid={testid}>
      {slides.map((src, i) => (
        <img
          key={`${src}-${i}`}
          src={resolve(src)}
          alt={alt}
          loading={i === 0 ? "eager" : "lazy"}
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ${i === idx ? "opacity-100" : "opacity-0"}`}
          data-testid={`${testid}-slide-${i}`}
        />
      ))}
      {slides.length > 1 && (
        <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1.5 z-10" data-testid={`${testid}-dots`}>
          {slides.map((_, i) => (
            <button
              key={i}
              onClick={() => setIdx(i)}
              className={`w-1.5 h-1.5 rounded-full transition-all ${i === idx ? "bg-white w-4" : "bg-white/50 hover:bg-white/80"}`}
              aria-label={`Go to slide ${i + 1}`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ImageCarousel;
